import styles from '../styles/Register.module.scss'
import techTalentStyles from '../styles/TechTalent.module.scss'
import axios from 'axios'
import React, { useState, useContext, useEffect } from 'react'
import {
	Row,
	Col,
	Form,
	Card,
	Button,
	Alert,
	Spinner
} from 'react-bootstrap'
// import { query } from 'graphqurl'
import UserContext from '../UserContext'
// import ReCAPTCHA from 'react-google-recaptcha'
import Link from 'next/link'
import { useRouter } from 'next/router'
import {
	useGoogleReCaptcha,
	// GoogleReCaptcha
} from 'react-google-recaptcha-v3'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

import { callingCode } from '../helpers/country'
interface VerifyMobileProps {
	setIsMobileVerified: any,
	countryCode: string,
	isTechTalent?: boolean
}


const VerifyMobile: React.FC<VerifyMobileProps> = (props: VerifyMobileProps) => {
	const { t } = useTranslation()
	const { executeRecaptcha } = useGoogleReCaptcha()
	const [countryCode, setCountryCode] = useState<string>(props.countryCode)

	useEffect(() => {
		console.log(countryCode)
	}, [countryCode])

	const [number, setNumber] = useState('')
	const [otp, setOtp] = useState('')
	const [accountExist, setAccountExist] = useState<boolean>(false)
	const [otpRequested, setOtpRequested] = useState<boolean>(false)
	const [otpVerificationError, setOtpVerificationError] = useState<boolean>(false)
	const [countdown, setCountDown] = useState(60)
	const [isLoading, setIsLoading] = useState(false)
	const { setUser } = useContext(UserContext)

	const router = useRouter()
	const isBroadcast = router.query.source === 'broadcast'
	const isRedirectedFromMPS = typeof router.query.source !== 'undefined' && router.query.source === 'MPS'
	const locale = router.locale?.toUpperCase()

	// const [isRecaptchaSolved, setIsReaptchaSolved] = useState(false)

	// const recaptchaRef = React.createRef<HTMLInputElement>()

	// const onReCAPTCHAChange = (captchaCode) => {
	// 	// If the reCAPTCHA code is null or undefined indicating that
	// 	// the reCAPTCHA was expired then return early
	// 	if(!captchaCode) {
	// 		return
	// 	}

	// 	console.log(captchaCode)

	// 	setIsReaptchaSolved(true)
	// 	// Else reCAPTCHA was executed successfully so proceed with the
	// 	// alert
	// 	// Reset the reCAPTCHA so that it can be executed again if user
	// 	// submits another email.
	// 	// recaptchaRef.current.reset();
	// }

	const requestOtp = (e: any): void => {
		e.preventDefault()
		e.stopPropagation()

		setIsLoading(true)

		// validate locale
		const countryList = ['SG', 'MY']
		const country = countryList.includes(locale as string) ? locale : 'SG'

		axios.post('/api/check-account', {
			number: number,
			callingCode: countryCode as string,
			country: country as string
		}).then((resp: any) => {
			if (resp.data.applicantExist === true && !isRedirectedFromMPS) {
				setAccountExist(true)
				setIsLoading(false)
			} else {
				handleOtp()
			}
		}).catch(() => {
			setIsLoading(false)
		})
	}

	const makeRequestOtp = async (): Promise<any> => {
		const token = await executeRecaptcha?.('otp')

		axios.get(`${process.env.NEXT_PUBLIC_OTP_REQUEST as string}?type=jobseeker&callingCode=${encodeURIComponent(countryCode.toString())}&number=${number.toString()}&captchaCode=${token}`).then(() => {
			setOtpRequested(true)
			setOtpVerificationError(false)
			setIsLoading(false)
		}).catch(() => {
			setIsLoading(false)
		})
	}

	useEffect(() => {
		if (otpRequested === true) {
			setTimeout(() => {
				setCountDown(countdown - 1)
			}, 1000)
		} else {
			setCountDown(60)
		}
	}, [countdown, otpRequested])

	const handleOtp = async (): Promise<any> => {
		setIsLoading(true)
		axios.post(process.env.NEXT_PUBLIC_OTP_LOGIN_ROUTE as string, {
			number: number,
		}).then(({ data }) => {
			if (data.applicant !== null) {
				// Authenticated
				// Store JWT in localStorage(Ignore the other ways first ...)
				window.localStorage.setItem('token', data.token)
				window.localStorage.setItem('profile', JSON.stringify(data.applicant))

				window.localStorage.setItem('login-date', JSON.stringify(dayjs()))
				// set Context
				setUser(data.applicant)
				// Redirect to Root page
				// router.push('/register').catch(err => console.error(err))
				props.setIsMobileVerified(true)
			} else {
				// Show Alert
				setOtpVerificationError(true)
				setOtpRequested(false)
			}
			setIsLoading(false)
		}).catch(() => {
			// console.error(err)
			setOtpVerificationError(true)
			setOtpRequested(false)
			setIsLoading(false)
		})
	}

	return (
		<Row className='justify-content-center pt-4 pb-4'>
			<Col xs={12} md={6}>
				<Card>
					<Card.Body className='pt-4 pb-4'>
						{otpRequested === false ?
							(
								<>
									{
										accountExist === true &&
										<Row className={styles.row}>
											<Col sm={11} md={11}>
												<Alert variant='success'>
													{t('register.existing_account')} <Link href={isBroadcast ? '/login?source=broadcast' : '/login'} passHref>{t('register.click_here')}</Link> {t('register.to_login')}
												</Alert>
											</Col>
										</Row>
									}
									<Form onSubmit={requestOtp}>
										<Row className={styles.row}>
											<Col sm={11} md={11}>
												<h4 className={styles.title}>{t('register.what_is_your_contact_number')}</h4>
												<Form.Group as={Col} xs='auto' controlId='formGridState'>
													<Form.Label>{t('register.country_code')}</Form.Label>
													<Form.Control className={styles.formControl} as='select' defaultValue={countryCode} onChange={e => { setCountryCode(e.target.value) }}>
														{callingCode().map((code: any, i: number) =>
															(
																<option key={i} value={`+${code.code as string}`}>+{code.code} - {code.english}</option>
															)
														)}
													</Form.Control>
												</Form.Group>
											</Col>
										</Row>
										<Row className={styles.row}>
											<Col sm={11} md={11}>
												<Form.Group as={Col} controlId='formGridZip' className='mb-3'>
													<Form.Label>{t('register.phone_number')}</Form.Label>
													<Form.Control className={styles.formControl}
														value={number}
														type='number'
														minLength={6}
														required
														onChange={e => { setNumber(e.target.value) }}
													/>
												</Form.Group>
												{
													otpVerificationError === true &&
													<Alert variant='danger' style={{ fontSize: '14px' }}>
														{t('register.error_otp')}
													</Alert>
												}
												{/* <div className='text-center mt-4'>
													<ReCAPTCHA
													ref={recaptchaRef}
													style={{ display: 'inline-block' }}
													size="normal"
													sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
													onChange={onReCAPTCHAChange}
												/>
												</div> */}
												<div className='text-center'>
													<Button
														type='submit'
														variant='primary'
														className={`text-white ${props.isTechTalent && techTalentStyles.primaryBtn}`}
														disabled={isLoading}
													>
														{isLoading ? <Spinner animation="border" size="sm" /> : t('apply_jobs_new.next')}
													</Button>
												</div>
											</Col>
										</Row>
									</Form>
								</>
							) : (
								<>
									<Form onSubmit={handleOtp}>
										<Row className={styles.row}>
											<Col sm={11} md={11}>
												<h4 className={styles.title}>{t('register.enter_otp_to_verify')}</h4>
												<Form.Group as={Col} controlId='formGridZip'>
													<Form.Label>{t('register.enter_otp')}</Form.Label>
													<Form.Control className={styles.formControl}
														type='number'
														minLength={6}
														required
														onChange={e => { setOtp(e.target.value) }}
													/>
												</Form.Group>
												<div className={styles.otp}>
													{countdown > 0 && <p className={styles.otpText}>{t('register.you_may_request_otp_again_in')}<b>{countdown}</b>{t('register.seconds')}</p>}
													{countdown <= 0 && <>
														<Button onClick={requestOtp} className={styles.otpText} variant='link'>{t('register.request_another_OTP')}</Button>
														<span>or</span>
														<Button onClick={() => { setOtpRequested(false) }} variant='link' className={styles.otpText}>{t('register.change_phone_number')}</Button>
													</>}
												</div>
												<div className='text-center mt-4'>
													<Button
														type='submit'
														variant='primary'
														className={`text-white ${props.isTechTalent && techTalentStyles.primaryBtn}`}
														disabled={isLoading}
													>
														{isLoading ? <Spinner animation="border" size="sm" /> : t('register.verify')}
													</Button>
												</div>
											</Col>
										</Row>
									</Form>
								</>
							)
						}
					</Card.Body>
				</Card>
			</Col>
		</Row>
	)
}

export default VerifyMobile
